// To call: store.dispatch('addExample', '')
import con from '@services/connection'
import { workspace } from '@constants/URL'

/**
 * Coletar salas do chat no servidor
 */
const loadRooms = async ({ commit, getters }, show_loading = true) => {
  if (getters['loadingRooms']) {
    return
  }
  if (show_loading) {
    commit('SET_LOADING_ROOMS', true)
  }
  console.log('Chat/actions:loadRooms')
  const r = await con.get(workspace.rooms)
  if (r.status === 200) {
    commit('SET_ROOMS', r.value)
  } else {
    commit('SET_ROOMS', [])
  }

  if (show_loading) {
    commit('SET_LOADING_ROOMS', false)
  }
}

const setLoadingRoom = ({ commit }, payload) => {
  commit('SET_LOADING_ROOMS', payload)
}

const incrementQtdUnread = ({ commit }, payload) => {
  commit('ADD_ROOM_COUNT_UNREAD', payload)
}

const readRoom = ({ commit }, payload) => {
  commit('SET_READ_ROOM', payload)

  con.put(workspace.room_messages + payload)
}

const selectRoom = ({ commit }, payload) => {
  commit('SELECT_ROOM', payload)
}

const unselectRoom = ({ commit }, payload) => {
  commit('UNSELECT_ROOM', payload)
}

// GlobalBus.$on(RELOAD.ROOMS, loadRooms)

export {
  loadRooms,
  setLoadingRoom,
  incrementQtdUnread,
  readRoom,
  selectRoom,
  unselectRoom,
}
